import { Component, Input, OnInit } from '@angular/core';
import { ProgressBarService, ProgressBarEvent, isPresent } from '../../services/progressbar.service';

@Component({
    moduleId: module.id.toString(),
    selector: 'ng2-progress-bar',
    template: `
        <div id="loading-bar" >
            <div class="bar" [style.width]="progress" [style.opacity]="show ? '1' : '0'">
                <div class="peg"></div>
            </div>
        </div>`
})
export class ProgressBarComponent implements OnInit {
    private progressEl: HTMLDivElement;
    private _progress: string = '0%';

    @Input() set progress(value: string) {
        if (isPresent(value)) {
            this._progress = value + '%';
        }
    }
    get progress(): string {
        return this._progress;
    }

    @Input() color: string = 'firebrick';
    @Input() height: string = '2px';
    @Input() show: boolean = true;

    constructor(private service: ProgressBarService) { }

    ngOnInit(): any {
        this.service.observable.subscribe((event: ProgressBarEvent) => {
            if (event.value > 0 ) {
                this.show = true;
            }
            else {
                this.show = false;
            }

            this.progress = event.value;
        });
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/common/progressbar/progressbar.component.ts
 **/